<template>
  <div style="padding: 1vw">
    <div style="display: flex; justify-content: space-between; align-items: flex-end; padding: 0 1vw">
      <div class="pageTitle">
        <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
          공지사항 관리
        </h3>
        <span class="pageDesc">
          공지사항을 등록하고 관리할 수 있습니다.
        </span>
      </div>
      <div style="display: flex; align-items: center;">
        <router-link to="/certilife/notice/write">
          <button
          class="btn btn-primary"
          type="button"          
          >
          작성하기
        </button>
      </router-link>
      </div>
    </div>
    <div class="filterWrap" style="">
      <div class="searchdropbox">
        <select v-model="condition" 
        id="itemCode"
        @change="getNoticesList(false)"
        >
          <option value="ALL" selected>전체</option>
          <option v-for="item in targetsList" :value="item.code" :key="item.code">{{ `${item.name}` }}</option>
        </select>  
      </div>
      <div class="searchinputbox">
        <select class="search-select" v-model="rowsPerPage" @change="handleRowsPerPage">
          <option :value="10">10개씩 보기</option>
          <option :value="20">20개씩 보기</option>
          <option :value="50">50개씩 보기</option>
        </select>
      </div>
    </div>
    <div class="container-wrapper">
      <a-table 
        class="ant-table-striped"
        size="small"
        v-if="responseData"
        :columns="columns"
        :data-source="responseData"
        :pagination="false"
        @resizeColumn="handleResizeColumn"
      >
        <template #emptyText>
          <div class="noResult">검색 결과가 없습니다.</div>
        </template>
      </a-table>
      <pagination 
        :page-info="paginationData"
        page-name="CustomerManage"
        @change-page="paginationHandler"
      />
    </div>
  <!-- 삭제 모달 -->
  <div
  class="modal fade"
  id="deleteyesno"
  tabindex="-1"
  aria-labelledby="resetModalLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered"
    style="justify-content: center !important"
  >
    <div
      class="modal-content"
      style="width: 70% !important; padding-top: 0.5vw"
    >
      <div class="modal-body" style="display: flex; flex-direction: column">
        <div style="text-align: center; padding-top: 1rem">
          <h4>글 삭제</h4>
          <h6>해당 공지사항을 삭제하시겠습니까?</h6>
        </div>
        <div style="display: flex; justify-content: center; margin-top: 2rem">
          <button
            style="margin-right: 1vw;"
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
          취소
          </button>
          <button
            type="button"
            class="btn btn-warning"
            @click="deleteNotice()"
          >
          삭제
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
  <div
  class="modal fade"
  id="isNoShowYesNo"
  tabindex="-1"
  aria-labelledby="resetModalLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered"
    style="justify-content: center !important"
  >
    <div
      class="modal-content"
      style="width: 70% !important; padding-top: 0.5vw"
      v-if="selectedNoticeObject"
    >
      <div class="modal-body" style="display: flex; flex-direction: column">
        <div style="text-align: center; padding-top: 1rem">
          <h4>{{selectedNoticeObject.isNoShowNotice?'노출':'비노출'}}</h4>
          <h6>해당 공지사항을 {{selectedNoticeObject.isNoShowNotice?'노출':'비노출'}}하시겠습니까?</h6>
        </div>
        <div style="display: flex; justify-content: center; margin-top: 2rem">
          <button
            style="margin-right: 1vw;"
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
          취소
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="updateIsNoShowNotice()"
          >
          확인
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
  </div>

</template>
<script>
import { convertDate, openDialog, convertMedicalDept, } from "../utils/utils";
import Pagination from "@/views/components/Pagination.vue";

export default {
  name: "noticesList",
  components: {
    Pagination,
  },
  data() {
    return {
      // 목록 받아오는 변수
      responseData: [],  

      targetsList: [], // 노출 대상 받아오기
      condition: "ALL", // 최초 검색필터는 전체

      listSize: 0,
      rowsPerPage: 10, 
      paginationData: {
        currentPage: 1, 
        totalPages: 0,
      },
      columns: [
        { key: 'targets', title: '노출 대상', dataIndex: 'targets', align: 'center',
          customRender: ({ record }) => this.convertTargetsToString(record.targets)
        },
        { key: 'medicalDept', title: '진료 과목', dataIndex: 'medicalDept', align: 'center',
          customRender: ({ record }) => this.convertMedicalDeptToString(record.medicalDept)
        },
        { key: 'title', title: '제목', dataIndex: 'title', align: 'center',
          customRender: ({ record }) => {
            return <div
            class="hoverPointer"
            onClick={() => this.routeToRead(record._id)}
            >
              { record.title }
              </div>
          }
        },
        { key: 'writer', title: '작성자', dataIndex: 'writer', align: 'center', },
        { key: 'isPopupNotice', title: '팝업 공지사항', dataIndex: 'isPopupNotice', align: 'center', 
          customRender: ({ record }) => record.isPopupNotice?'팝업등록완료':''
        },
        {
          key: 'createAt',
          title: '등록 일시',
          dataIndex: 'createAt',
          align: 'center',
          
          customRender: ({ record }) => this.convertDate(record.createAt)
        },
        { key: 'isNoShowNotice', title: '비노출', dataIndex: 'isNoShowNotice', align: 'center', 
          customRender: ({ record }) => {
            return <div
                    style="display: flex; gap: 8px; justify-content: center;"
                  >
                    <div
                      
                      type="button"
                      class="certi-custom-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#isNoShowYesNo"
                      onClick={() => this.selectNoticeObject(record)}
                    >
                      {record.isNoShowNotice?'노출':'비노출'}
                    </div>
                  </div>
          }
        },
        {
          key: 'manage',
          title: '관리',
          dataIndex: 'manage',
          align: 'center',
          customRender: ({ record }) => {
              return <div
                    style="display: flex; gap: 8px; justify-content: center;"
                  >
                  <router-link to={`/certilife/notice/${record._id}/edit`}>
                    <div type="button" class="certi-custom-btn">
                      수정
                    </div>
                  </router-link>
                  <div
                  type="button"
                  class="certi-custom-btn"
                  data-bs-toggle="modal"
                  data-bs-target="#deleteyesno"
                  onClick={() => this.selectNotice(record._id)}
                >
                  삭제
                </div>
                </div>
          }
        },
      ],
      selectedNoticeObject:null
    };
  },
  
  async mounted() {
    await this.getTargets();
    const obj = {};
    obj.page = this.paginationData.currentPage;
    await this.paginationHandler(obj);
  },
  methods: {
    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getNoticesList();
    },


    handleResizeColumn(w, col) {
      col.width = w;
    },
    // 주요 API

    // 노출 대상 가져오기
    async getTargets() {
      try {
        const response = await this.$apiInstance.get(`/notices/targets/list`);
        if(response.status === 200 || response.status === 201) {
          this.targetsList = response.data;
        } 
      } catch (error) {
        console.log(error);
      }
    },

    async updateIsNoShowNotice() {
      try {
        const response = await this.$apiInstance.put(`/notices/update-is-no-show-notice/${this.selectedNoticeObject._id}`);
        if(response.status === 200 || response.status === 201) {
          if(response.data.isNoShowNotice){
            await openDialog("해당 공지사항이 비노출 되었습니다.","success", "확인")
            .then(() => {
              location.reload();
            });
          }else{
            await openDialog("해당 공지사항이 노출 되었습니다.","success", "확인")
            .then(() => {
              location.reload();
            });

          }
        } 
      } catch (error) {
        console.log(error);
      }
    },

    // 공지사항 목록 가져오기
    async getNoticesList() {
      const params = {};
      params.page = this.paginationData.currentPage;
      params.limit = this.rowsPerPage;
      params.target = this.condition;

      try {
        const response = await this.$apiInstance.get(`/notices`, {params}); 
        if(response.status === 200 || response.status === 201) {
          this.responseData = response.data.docs;
          this.listSize = response.data.totalDocs;
          this.paginationData.totalPages = response.data.totalPages;
          for (let i = 0; i < this.responseData.length; i++) {
            this.responseData[i].index =
              this.listSize - i - (this.paginationData.currentPage - 1) * this.rowsPerPage;
          }
        }
      } catch(error) {
        console.log(error);
      }
    },
    async handleRowsPerPage() {
      this.paginationData.currentPage = 1;
      await this.getNoticesList();
    },

    // 공지사항 삭제
    async deleteNotice() {
      try {
        const response = await this.$apiInstance.delete(
          `/notices/${this.selectedNotice}`,
        )
        if(response.status === 200 || response.status === 201) {
          await openDialog("해당 공지사항이 삭제되었습니다.","success", "확인")
          .then(() => {
            location.reload();
          });
        } else {
          await openDialog("공지사항 삭제에 실패하였습니다.", "error", "확인");
        }
      } catch(error) {
        console.log(error);
        await openDialog("공지사항 삭제에 실패하였습니다.", "error", "확인");
      }
    },


    // 기타 ManuManage용 utils
    
    // 글 보기로 이동
    routeToRead(id) {
      this.$router.push({ name: "noticeRead", params: {id: id} });
    },
    // 날짜, 시간 포맷에 맞추기
    convertDate,

    // 보기, 수정, 삭제 시 선택
    selectNotice(noticeId) {
      this.selectedNotice = noticeId;
    },
    selectNoticeObject(notice) {
      this.selectedNoticeObject = notice;
    },

    // 노출 대상 변환
    convertTargetToText(code) {
      const target = this.targetsList.find(item => item.code === code);
      return target ? target.name : "-";
    },

    convertMedicalDeptToString(array) {
      let targetString = '';
      if(array && array.length > 0) {
        for(const target of array) {
          targetString += `${convertMedicalDept(target)} / `;
        }
        return targetString.slice(0, -2);
      } else {
        return "-";
      }

    },

    // 노출 대상(들) 스트링으로 변환
    convertTargetsToString(array) {
      let targetString = "";
      if(array && array.length > 0) {
        for(const target of array) {
          targetString += `${this.convertTargetToText(target)} / `;
        }
        return targetString.slice(0, -2);
      } else {
        return "-";
      }
    }

  },
};
</script>
